<template>
  <div id="addArea" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo catalogoTitle">Agregar Área</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="enterprise" id="enterprise" v-model="enterprise">
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="nomarea">Nombre de área</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            type="text"
            id="nomarea"
            name="nomarea"
            class="px-3"
            style="width: 90% !important"
            v-model="area"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="corto">Nombre corto</label>
        </v-col>
        <v-col cols="12" sm="4" class="pa-2 com">
          <input
            type="text"
            id="corto"
            name="corto"
            class="px-3"
            style="width: 90% !important"
            v-model="nombreCorto"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Nivel de Área</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="level" id="level" v-model="level">
            <option disabled value="0">Seleccione nivel</option>
            <option
              v-for="level in niveles"
              :key="level.id"
              v-bind:value="level.id"
            >
              {{ level.name }}
            </option>
          </select>
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validar()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ titulo }}</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de dar de alta el Área?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="cancel()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardarAreaA()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alta de Área</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      show: false,
      stepn: "11-N",
      error: false,
      errors: [],
      estructura: 0,
      niveles: [],
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      respuesta: "",
      titulo: "",
      nivel: 0,
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
      catalogo: true,
      lista: false,
      area: 0,
      level: 0,
      area: "",
      nombreCorto: "",
      nombreArchivo: "",
      enterprise: 0,
      enterprises: [],
      advice: false,
      confirmation: false,
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    regresar() {
      this.lista = false;
      this.catalogo = true;
      this.enterprise = 0;
      this.area = "";
      this.nombreCorto = "";
      this.level = 0;
      this.$router.push("/areasList");
    },
    validar() {
      this.errors = [];
      if (this.enterprise == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.area == "" || this.area == " ") {
        this.errors.push("Se debe especificar el nombre de Área.");
      }
      if (this.nombreCorto == "" || this.nombreCorto == " ") {
        this.errors.push("Se debe especificar el nombre Corto del Área.");
      }
      if (this.level == 0) {
        this.errors.push("Se debe especificar el nivel de Área.");
      }
      if (this.errors.length == 0) {
        this.advice = true;
      } else {
        this.titulo = "Agregar Área";
        return (this.error = true);
      }
    },
    guardarAreaA() {
      this.advice = false;
      this.show = true;
      axios
        .post(Server + "/areas", {
          NombreArea: this.area,
          NombreAreaCorto: this.nombreCorto,
          NivelJerarquico: parseInt(this.level),
          EmpresaId: this.enterprise,
        })
        .then((response) => {
          console.log(response);
          this.area = "";
          this.nombreCorto = "";
          localStorage.idEmpresa = this.enterprise;
          this.enterprise = "";
          this.level = 0;
          this.respuesta = "El área fue guardada con éxito";
          this.show = false;
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.area = "";
          this.nombreCorto = "";
          this.enterprise = "";
          this.level = 0;
          this.respuesta = "El área no fue almacenada";
          this.confirmation = true;
        });
    },
    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        console.log("archivo bn");
        var selectedFile = event.target.files[0];
        //this.formData.append("file", selectedFile, selectedFile.name);
      }
    },

    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },

    cancel() {
      this.area = "";
      this.nombreCorto = "";
      this.enterprise = 0;
      this.level = 0;
      this.advice = false;
    },

    aux() {
      this.confirmation = false;
      this.area = "";
      this.nombreCorto = "";
      this.enterprise = "";
      this.level = 0;
      this.$router.push("/areasList");
    },
  },
  created() {
    this.nombre();
    this.listar();
    for (let index = 1; index <= 99; index++) {
      this.niveles.push({
        id: index,
        name: index.toString(),
      });
    }
  },
};
</script>